import { render } from "./nameComponent.vue?vue&type=template&id=0d49a178&scoped=true"
import script from "./nameComponent.vue?vue&type=script&lang=js"
export * from "./nameComponent.vue?vue&type=script&lang=js"

import "./nameComponent.vue?vue&type=style&index=0&id=0d49a178&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d49a178"]])

export default __exports__